import candidate from './candidate'
import projects from './projects'
import vacancies from './vacancies'

export default {
  candidate,
  projects,
  vacancies
}
